import type { Evaluation } from '@compass/client/types/evaluation';
import { cn } from '@utils/index';
import React from 'react';

import type { TableColumnConfig } from '@/types/table';

import { getQcScoreToneClasses } from '../qcDetail.utils';
import { SECTION_SCORE_SORT_FIELD_PREFIX, type SectionScoreColumn } from '../sectionScores';
import { formatAggregateScore } from '../utils';

const SECTION_SCORE_COLUMN_WIDTH = 150;

export const buildSectionScoreColumns = (
  columns: SectionScoreColumn[],
): TableColumnConfig<Evaluation>[] =>
  columns.map(({ sectionId, header }) => ({
    key: `${SECTION_SCORE_SORT_FIELD_PREFIX}${sectionId}`,
    header,
    width: SECTION_SCORE_COLUMN_WIDTH,
    sortable: true,
    sortField: `${SECTION_SCORE_SORT_FIELD_PREFIX}${sectionId}`,
    accessor: item => {
      // Absent = the section did not apply to this evaluation; 0 is a real score.
      const score = item.section_scores?.[sectionId];
      // getQcScoreToneClasses(undefined) is the muted tone, so "—" needs no special case.
      return (
        <span className={cn('text-sm font-semibold', getQcScoreToneClasses(score))}>
          {score === undefined ? '—' : formatAggregateScore(score)}
        </span>
      );
    },
  }));
